var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#B7CEE5",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8613 25.7505C37.0566 25.5553 37.0566 25.2387 36.8613 25.0434L33.6793 21.8614C33.4841 21.6662 33.1675 21.6662 32.9722 21.8614C32.777 22.0567 32.777 22.3733 32.9722 22.5685L35.8007 25.397L32.9722 28.2254C32.777 28.4207 32.777 28.7372 32.9722 28.9325C33.1675 29.1278 33.4841 29.1278 33.6793 28.9325L36.8613 25.7505ZM12.6982 25.897H36.5078V24.897H12.6982V25.897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallActive);
export default __webpack_public_path__ + "static/media/ArrowSmall_Active.4f5fb4af5a91e81830f4ba5bdd3201d4.svg";
export { ForwardRef as ReactComponent };